<script>
import moment from 'moment'
export default {
  data: () => ({
    // url: 'http://maru-app.com/himawari-new/php/'
    // url: 'http://try-kk.com/shifcal/php/'
    // url: 'http://clear-kyoto.net/shift/php/'
    url: 'http://try-sol.com/shift-demo/php/'
    // url: 'http://localhost/shifcal/php/'
    // url: 'http://192.168.3.4/shifcal/php/'
  }),
  methods: {
  },
  mounted () {
    moment.lang('ja');
  },

}
</script>
